import { createStore, filterNil } from '@ngneat/elf';
import * as braze from '@braze/web-sdk';
import {
  getEntity,
  selectAllEntities,
  setEntities,
  upsertEntitiesById,
  withEntities,
} from '@ngneat/elf-entities';

type Card = braze.ClassicCard & { id: string };

const contentCardsStore = createStore(
  { name: 'content-cards' },
  withEntities<Card>()
);

/** Snapshots */

export const contentCardsStoreSnapshot = () => contentCardsStore.getValue();

/** Exposed Variables and Observables */

export const contentCards$ = contentCardsStore.pipe(
  selectAllEntities(),
  filterNil()
);

export const getContentCardById = (id: string) => {
  return contentCardsStore.query(getEntity(id)) ?? null;
};

/** Updater Functions */

export function updateContentCards(contentCards: braze.ContentCards) {
  const cards = contentCards.cards.map<Card>((card) => {
    card.id = card.id ?? '';
    return card as Card;
  });

  contentCardsStore.update(setEntities(cards));
}

export function updateContentCardById(contentCard: braze.Card) {
  if (typeof contentCard.id === 'string') {
    contentCardsStore.update(
      upsertEntitiesById(contentCard.id, {
        updater: contentCard,
        creator: (id) => {
          contentCard.id = id;
          return contentCard as Card;
        },
      })
    );
  }
}

export function resetContentCardsStore() {
  contentCardsStore.reset();
}
